import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { Router } from '@angular/router';
import packageInfo from '../../../../../../../package.json';
import { environment } from '../../../../../../environments/environment';
import { Observable, of } from 'rxjs';
import {
    ApiServiceInterface,
    FormServiceInterface,
    OfflineQueue,
    OfflineServiceInterface,
    ThemeServiceInterface,
    UserAccountInterface,
    UserServiceInterface,
} from '@hutsix/ngxh6';
import { ToastService } from '@hutsix/ngxh6';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class NavbarComponent {
    public env: string = environment.env;
    public version: string = packageInfo.version + (environment.env === 'staging' ? '-staging' : '');
    public offlineQueue$: Observable<OfflineQueue[]>;

    constructor(
        public router: Router,
        public toastr: ToastService,
        @Inject('UserService') public userService: UserServiceInterface,
        @Inject('FormService') public formService: FormServiceInterface,
        @Inject('OfflineService') public offline: OfflineServiceInterface,
        @Inject('ApiService') public api: ApiServiceInterface,
        @Inject('ThemeService') public themeService: ThemeServiceInterface,

        public cdRef: ChangeDetectorRef,
    ) {
        this.offlineQueue$ = this.getOfflineQueue();
    }

    update(): void {
        this.offlineQueue$ = this.getOfflineQueue();
    }

    private getOfflineQueue(): Observable<OfflineQueue[]> {
        // getOfflineQueue() dereferences userService.user.id internally, so skip it
        // when there is no logged-in user (e.g. on the /login page) to avoid a TypeError.
        if (!this.userService.user?.id) return of([]);
        return this.offline.getOfflineQueue();
    }

    clearCaches(): void {
        if (!confirm('All cached data will be removed. You will be required to re-sync to use offline capabilities. Are you sure?')) return;

        this.api.clearCaches().subscribe(res => {
            // Release any stuck offline-sync lock so the UI un-dims and re-sync works.
            this.userService.offline_lock = false;
            this.userService.offlineSyncing = false;
            if (res) {
                this.toastr.success('Caches cleared!');
            } else {
                this.toastr.error('Try again.', 'Something went wrong.');
            }
        });
    }

    getUserType() {
        const roles = this.userService.account.user.roles;

        if (roles && roles.length > 0) {
            if (roles.some((role: string) => role.includes('RAMP'))) {
                return 'RAMP';
            } else if (roles.some((role: string) => role.includes('CSP'))) {
                return 'CSP';
            }
        }

        return ''; // Return an empty string if no matching role is found
    }

    protected readonly location = location;
}
